module.exports = __webpack_public_path__ + "static/media/team-mgr.3e71667c.svg";